<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">身份证信息</span>
      </div>
      <div style="margin-top: 5px;font-weight: normal">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">身份证信息</span>
        </div>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>温馨提示</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span style="color: red">{{ idCardInfo.grifterString }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>审核状态</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span style="color: red">{{ idCardInfo.idCardStatus }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>联网核对</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
          <span style="color: red;">{{ idCardInfo.networkCheckStatusStr }}
            <el-button size="mini" type="primary" @click="networkCheck">联网查询</el-button>
          </span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>上次联网结果</span>
          </el-col>
          <el-col :span="15" style="padding-left:2%;text-align: left">
            <span style="color: red; font-size: 10px;" v-html="idCardInfo.lastNectworkCheckResult"></span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>提交时间</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.commitDateTime }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>用户账号</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.userName }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>上级用户</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.upBusinessUser }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>业务员</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.businessUser }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>用户微信</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.wechart }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>用户QQ</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.QQNumber }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>手机号归属地</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span style="color: red">{{ idCardInfo.phoneLocation }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>真实姓名</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.realyUserName }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>身份证号码</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.idCardNumber }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>身份证验证信息</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span v-for="imgItem in idCardInfo.idCardImages">
              <el-image style="margin:5px;width: 210px; height: 210px" :src="imgItem"
                        :preview-src-list="idCardInfo.idCardImages" lazy></el-image>
            </span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>开户行</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.backCardName }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>银行卡号</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.backCardNumber }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:1%;">
          <el-col :span="9" style="text-align: right">
            <span>开户行地区</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idCardInfo.backArea }}</span>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 5px;">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">收款账号</span>
        </div>
        <div v-for="(reviewItem, index) in idCardInfo.recivewMoneyAccountInfos">
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>账号类型</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.accountType }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>姓名</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.userName }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>账号/卡号</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.cardNumber }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:1%;">
            <el-col :span="9" style="text-align: right">
              <span>收款码</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>
                <el-image style="width: 260px; height: 260px" :src="reviewItem.recivewCordImage"></el-image>
              </span>
            </el-col>
          </el-row>
          <div v-show="isEndWithAccount(index)">
            <el-divider></el-divider>
          </div>
        </div>
        <div style="margin:1%;">
          <el-divider></el-divider>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>审核状态</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span style="color: red">{{ idCardInfo.idCardStatus }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>审核操作</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <el-select v-model="reviewStatus" clearable size="mini">
                <el-option
                    v-for="item in options"
                    :key="item.status"
                    :label="item.statusName"
                    :value="item.status"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>审核原因</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <el-input v-model="reviewBecause" size="mini"></el-input>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>温馨提示</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span style="color: red">{{ idCardInfo.grifterString }}</span>
            </el-col>
          </el-row>
        </div>
        <div style="width: 100%;padding:1% 0;text-align: center;background-color: lightgray;">
          <el-button @click="goBack()" size="mini" icon="el-icon-back">返 回</el-button>
          <el-button @click="idcardChecked" size="mini" type="primary" icon="el-icon-folder-checked">审 核</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {changeIdcardStatus, networkCheck, queryIdCardDetail} from "../../api/b2cbusiness/b2c_customerinfo";
import {isObjectEmpty, isStrEmpty} from "../../lib/utils";

export default {
  name: "IdCardDetail",
  data() {
    return {
      options:[{
        status:"202111300002",
        statusName:"未通过"
      },
        {
          status:"202111300003",
          statusName:"通过"
        }],
      reviewStatus:"202111300002",
      reviewBecause:"",
      idCardInfo: {},
      recivewMoneyAccountInfos: []
    }
  },
  computed: {
    isEndWithAccount() {
      return function (index) {
        console.log(index, this.recivewMoneyAccountInfos.length)
        if (index == (this.recivewMoneyAccountInfos.length - 1)) {
          console.log(index, this.recivewMoneyAccountInfos.length)
          return false;
        } else {
          return true;
        }
      }
    }
  },
  mounted() {
    if (!isStrEmpty(this.$route.query) && !isObjectEmpty(this.$route.query)){
      sessionStorage.setItem('idcardDetail', JSON.stringify(this.$route.query));
    }
    queryIdCardDetail(JSON.parse(sessionStorage.getItem('idcardDetail'))).then(res => {
      if (res.success) {
        console.log(res.data)
        Object.assign(this.idCardInfo, res.data);
        Object.assign(this.idCardInfo, res.data.customerInfo);
        Object.assign(this.idCardInfo, res.data.idcardInfo);
        this.recivewMoneyAccountInfos = res.data.recivewMoneyAccountInfos;
        console.log(this.idCardInfo)
        this.$forceUpdate();
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods: {
    networkCheck() {
      networkCheck({
        idCardId: this.idCardInfo.idCardId,
        userName: this.idCardInfo.realyUserName,
        userNumber: this.idCardInfo.idCardNumber
      }).then(res => {
        if (res.success) {
          this.getData();
        }
      });
    },
    goBack(){
      this.$router.back();
      this.$store.commit("removeTab", "/home/idcardetail");
    },
    idcardChecked(){
      changeIdcardStatus({idCardId: this.idCardInfo.idCardId, status:this.reviewStatus, because:this.reviewBecause}).then(res=>{
        if (res.success){
          this.$router.back();
          this.$store.commit("removeTab", "/home/idcardetail");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        this.$router.back();
        this.$store.commit("removeTab", "/home/idcardetail");
      });
    },
    getData() {
      queryIdCardDetail(this.$route.query).then(res => {
        if (res.success) {
          console.log(res.data)
          Object.assign(this.idCardInfo, res.data);
          Object.assign(this.idCardInfo, res.data.customerInfo);
          Object.assign(this.idCardInfo, res.data.idcardInfo);
          this.recivewMoneyAccountInfos = res.data.recivewMoneyAccountInfos;
          console.log(this.idCardInfo)
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
